import { twMerge } from 'tailwind-merge';

function PageTitle({ children, className }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={twMerge('text-3xl font-medium text-neutral-900', className)}>{children}</h2>;
}

export { PageTitle };
